import React from "react"
import { MdOutlineLightbulb } from "react-icons/md"
import styles from "./onboarding.module.css"

const SetupGuide = ({ icon, title, items = [], note }) => (
    <section className={styles.guide}>
        <div className={styles.guideHeader}>
            <div className={styles.guideIcon}>{icon}</div>
            <div>
                <span>O que você fará</span>
                <h2>{title}</h2>
            </div>
        </div>
        <ol className={styles.guideSteps}>
            {items.map((item, index) => (
                <li key={item.title}>
                    <span className={styles.guideNumber}>{index + 1}</span>
                    <div>
                        <strong>{item.title}</strong>
                        <p>{item.description}</p>
                    </div>
                </li>
            ))}
        </ol>
        {note && <div className={styles.guideNote}><MdOutlineLightbulb /><span>{note}</span></div>}
    </section>
)

export default SetupGuide
